import React, { FC, Fragment, useState } from 'react';
import { ArrowLeftIcon, SurgeFilledIcon } from 'cokitchen-icons';
import { Input, BaseModal } from '@cokitchen/cokitchen-components';
import { ReviewType } from 'models/review.model';
import { BrandType } from 'models/brand.model';
import UserRating from 'components/base/user-rating';
import { getOrderStatus, getSimpleDateFormat, getUserName } from 'utils/functions';
import OrderStatus from 'components/base/order-status';
import { OrderType } from 'models/order.model';
import OrderDetail from 'pages/order-details';

type Props = {
  review: ReviewType;
  brand: BrandType;
  isAllSelected: boolean;
  markIssue?: () => void;
  onBrandSelect: () => void;
  isResolved?: boolean;
};

const ReviewCard: FC<Props> = ({
  review,
  brand,
  isAllSelected,
  markIssue,
  onBrandSelect,
  isResolved
}) => {
  const dateObj = new Date(review.created_at);
  const time = dateObj.toLocaleString('en-NG', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  const name = getUserName(review.user);

  const order_code = review?.order?.order_code?.toLowerCase();
  const [showDetails, setShowDetails] = useState(false);

  const closeOrderModal = () => {
    setShowDetails(false);
  };

  return (
    <Fragment>
      <div className='border border-gray-border rounded-lg flex flex-col'>
        <div className='grow px-4 py-3 space-y-2'>
          <div className='flex items-center gap-2 flex-wrap justify-between'>
            <h4
              className='font-medium  text-base text-gray-5 cursor-pointer'
              onClick={() => setShowDetails(true)}>
              #{review.order.order_code?.toUpperCase()}
            </h4>
            {!isResolved ? (
              <Input
                type='checkbox'
                readOnly
                checked={false}
                onChange={markIssue}
                className='scale-[90%] text-sm'
                label='Mark as resolved'
                labelDirection='left'
              />
            ) : (
              <div className='cursor-pointer inline-flex items-center gap-1 rounded-2xl border-2 border-blue-5 text-xs my-1 py-1 px-2 bg-[#f0f7fb] text-blue-5'>
                <SurgeFilledIcon className='w-4 h-4' /> Resolved
              </div>
            )}
          </div>
          <div className='flex items-center gap-2 py-2 text-xs'>
            <p className='flex min-w-fit items-center gap-2 text-sm'>{name}</p>
            <div className='ml-auto whitespace-nowrap flex items-center gap-2'>
              <p>{getSimpleDateFormat(review.created_at)}</p>
              <div className='bg-gray-2 min-w-[8px] w-2 h-2 rounded-full'></div>
              <div>{time}</div>
            </div>
          </div>
          <div className='flex items-center gap-1 py-1 text-xs'>
            <div className='ml-auto'>
              <UserRating rating={review?.rate} />
            </div>
          </div>

          <p className='flex items-start gap-2 mt-4 text-sm text-[#3e3e3e]'>{review.comment}</p>
        </div>
        <div className='border-t border-gray-border py-2 px-4 flex justify-between items-center'>
          {isAllSelected && (
            <p
              className='flex min-w-fit items-center gap-2 text-sm hover:underline'
              role='button'
              onClick={onBrandSelect}>
              <img className='w-[28px] h-[28px]' src={brand.logo} />
              {brand.name}
            </p>
          )}
          <div className='flex items-center gap-2 py-2 text-xs'>
            <p>Review time </p>
            <div className='bg-gray-2 min-w-[8px] w-2 h-2 rounded-full'></div>
            <div className='flex items-center gap-2'>{getSimpleDateFormat(review.created_at)}</div>
          </div>
        </div>
      </div>
      {showDetails && (
        <BaseModal
          position='right'
          isOpen
          onRequestClose={closeOrderModal}
          size='wide'
          title={
            <div className='flex flex-wrap lg:flex-nowrap gap-2 items-center'>
              <button onClick={closeOrderModal}>
                <ArrowLeftIcon className='w-6 h-6' />
              </button>
              <div className='font-semibold text-2xl'>Order #{order_code?.toUpperCase()}</div>

              <div className='basis-full lg:basis-auto'>
                <OrderStatus type={getOrderStatus(review.order as OrderType)} />
              </div>
            </div>
          }>
          <OrderDetail orderCode={order_code} />
        </BaseModal>
      )}
    </Fragment>
  );
};

export default ReviewCard;
